<template>
  <v-form ref="form" class="form">
    <DialogValueFilterIngestion
      :project="project"
      :dialog.sync="dialog"
      :valueFilter.sync="ingestion.value_filter"
      :filterType.sync="ingestion.filter_type"
      :timeFilter.sync="ingestion.time_filter"
      :filter-label="filterLabel"
    ></DialogValueFilterIngestion>
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="ingestion.name"
          :label="$t('ingestions.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('name')]
          "
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-autocomplete
          v-model="ingestion.filter_type"
          :items="filter_types"
          :label="$t('ingestions.filter-type')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('filter_type')]"
          :readonly="readonly"
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="ingestion.value_filter"
          :label="$t('ingestions.value-filter')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  rules.requiredWithEmptyString,
                  backEndValidation('value_filter')
                ]
          "
          append-outer-icon="mdi-pencil"
          v-on:click:append-outer="setFilterName('value-filter')"
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-autocomplete
          v-model="ingestion.time_type"
          :items="time_types"
          :label="$t('ingestions.time-type')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('time_type')]"
          :readonly="readonly"
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="ingestion.time_filter"
          :label="$t('ingestions.time-filter')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  rules.requiredWithEmptyString,
                  backEndValidation('time_filter')
                ]
          "
          append-outer-icon="mdi-pencil"
          v-on:click:append-outer="setFilterName('time-filter')"
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-combobox
          :items="symbols.map(i => i.symbol)"
          v-model="ingestion.symbol"
          @change="() => setSymbolName('symbol_name', ingestion.symbol)"
          :label="$t('ingestions.symbol')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('symbol')]
          "
          :readonly="readonly"
        ></v-combobox>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="ingestion.symbol_name"
          :label="$t('ingestions.symbol-name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.required, backEndValidation('symbol_name')]
          "
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="ingestion.normalization_factor"
          :label="$t('ingestions.normalization-factor')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.required, backEndValidation('normalization_factor')]
          "
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-switch
          v-model="ingestion.accumulated"
          :label="$t('ingestions.accumulated')"
          color="primary"
          :loading="resourceLoading"
          :readonly="readonly"
        ></v-switch>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-autocomplete
          v-model="ingestion.align_interval"
          :items="alignIntervals"
          item-text="title"
          item-value="value"
          :label="$t('ingestions.align-interval')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.requiredWithNull, backEndValidation('align_interval')]
          "
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-autocomplete
          v-model="ingestion.monitoring_interval"
          :items="monitoringIntervals"
          :label="$t('ingestions.monitoring-interval')"
          :loading="resourceLoading"
          item-text="title"
          item-value="value"
          :rules="
            resourceLoading
              ? []
              : [
                  rules.requiredWithNull,
                  backEndValidation('monitoring_interval')
                ]
          "
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-combobox
          :items="monitoringModes"
          item-text="title"
          item-value="value"
          v-model="monitoringMode"
          :label="$t('ingestions.monitoring-mode')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.required, backEndValidation('monitoring_mode')]
          "
          :readonly="readonly"
        ></v-combobox>
      </v-col>
    </v-row>
    <v-btn
      color="primary mr-3"
      v-on:click="save()"
      :loading="loading"
      :disabled="readonly"
    >
      <v-icon left>{{ $props.button_icon }}</v-icon>
      {{ $t(`ingestions.${$props.button_title}`) }}
    </v-btn>
  </v-form>
</template>

<script>
import { rules } from "@/components/mixins/rules";
import { projectPermissions } from "@/components/mixins/projects/projectPermissions";
import DialogValueFilterIngestion from "@/components/projects/metering/ingestions/DialogValueFilterIngestion.vue";

export default {
  name: "FormIngestion",
  components: { DialogValueFilterIngestion },
  mixins: [rules, projectPermissions],
  data: () => ({
    dialog: false,
    loading: false,
    filterLabel: "value-filter",
    filter_types: ["jsonpath", "xpath", "regex"],
    time_types: ["auto", "epoch", "iso8601"],
    monitoringMode: "Self Learning",
    alignInterval: "",
    monitoringInterval: ""
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    ingestion: {
      default: function() {
        return {
          accumulated: true,
          time_filter: "",
          value_filter: "",
          time_type: "auto",
          align_interval: null,
          monitoring_interval: null
        };
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    },
    permission: {
      type: String,
      default: ""
    }
  },
  computed: {
    symbols() {
      return this.$store.getters["presetStore/getSymbolPreset"];
    },
    project_id() {
      return this.$route.params.project_id;
    },
    project() {
      return this.$store.getters["projectStore/getCurrentItem"];
    },
    monitoringModes() {
      return this.$store.getters[
        "projectMeteringStore/ingestionStore/getMonitoringMode"
      ].map(mode => ({
        title: this.$t(mode.text),
        value: mode.value
      }));
    },
    alignIntervals() {
      return [
        { text: this.$t("ingestions.detect"), value: null },
        { text: this.$t("ingestions.15_minutes"), value: "PT15M" },
        { text: this.$t("ingestions.30_minutes"), value: "PT30M" },
        { text: this.$t("ingestions.1_hour"), value: "PT1H" }
      ].map(interval => ({
        title: this.$t(interval.text),
        value: interval.value
      }));
    },
    monitoringIntervals() {
      return [
        { text: this.$t("ingestions.detect"), value: null },
        {
          text: this.$t("ingestions.15_minutes"),
          value: "PT15M"
        },
        {
          text: this.$t("ingestions.20_minutes"),
          value: "PT20M"
        },
        { text: this.$t("ingestions.30_minutes"), value: "PT30M" },
        { text: this.$t("ingestions.1_hour"), value: "PT1H" },
        { text: this.$t("ingestions.2_hours"), value: "PT2H" },
        { text: this.$t("ingestions.3_hours"), value: "PT3H" },
        { text: this.$t("ingestions.4_hours"), value: "PT4H" },
        { text: this.$t("ingestions.6_hours"), value: "PT6H" },
        { text: this.$t("ingestions.8_hours"), value: "PT8H" },
        { text: this.$t("ingestions.12_hours"), value: "PT12H" },
        { text: this.$t("ingestions.24_hours"), value: "PT24H" }
      ].map(interval => ({
        title: interval.text,
        value: interval.value
      }));
    },
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions(this.permission);
      }
    }
  },
  watch: {
    ingestion() {
      this.monitoringMode = this.monitoringModes.find(
        mode => mode.value === parseInt(this.ingestion.monitoring_mode)
      );
    },
    monitoringMode() {
      if (this.monitoringMode) {
        this.ingestion.monitoring_mode = this.monitoringMode.value;
      }
    },
    alignInterval() {
      if (this.alignInterval) {
        this.ingestion.align_interval = this.alignInterval;
      }
    },
    monitoringInterval() {
      if (this.monitoringInterval) {
        this.ingestion.monitoring_interval = this.monitoringInterval;
      }
    },
    accumulated() {
      if (this.accumulated) {
        this.ingestion.accumulated = this.accumulated;
      }
    },
    "ingestion.time_filter": function(newVal) {
      if (!newVal) {
        this.ingestion.time_filter = "";
      }
    },
    "ingestion.value_filter": function(newVal) {
      if (!newVal) {
        this.ingestion.value_filter = "";
      }
    }
  },
  methods: {
    save(callback = this.defaultCallbackForSave) {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let item = {
          ...this.ingestion,
          project_id: this.project_id,
          id: this.$route.params.id
        };
        this.$store
          .dispatch(this.$props.dispatch, {
            item,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            }),
            onSuccess: item => {
              if (item) {
                callback(item);
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    defaultCallbackForSave(item) {
      this.$store.commit("projectMeteringStore/ingestionStore/set", {
        item
      });
      this.$router.push({
        name: "ingestion",
        params: {
          id: item.id
        }
      });
    },
    setSymbolName(parameterName, symbol) {
      let currentSymbol = this.symbols.find(i => i.symbol === symbol);
      if (currentSymbol) {
        this.ingestion[parameterName] = this.$t(currentSymbol.name);
      }
    },
    setFilterName(filterLabel) {
      this.filterLabel = filterLabel;
      this.setDialog(true);
    },
    setDialog(status) {
      this.dialog = status;
    }
  }
};
</script>
